import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  sectionContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  cardRow: {
    display: "grid",
    gap: "10px",
    width: "100%",
    direction: "rtl",
  },
  cardRow2: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
  cardRow1: {
    gridTemplateColumns: "1fr",
  },
  cardRow3: {
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  },
  sectionTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
  },
  tablesWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "100%",
    direction: "rtl",
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: "16px",
  },
  tableBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  tableHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    direction: "rtl",
    gap: "12px",
  },
  tableTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
  },
  addRowButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    height: 42,
    minHeight: 42,
    boxSizing: "border-box",
    padding: "10px 16px",
    borderRadius: "4px",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "140%",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    "& .MuiButton-startIcon": {
      margin: 0,
    },
    "& .MuiButton-endIcon": {
      margin: 0,
    },
  },
  table: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: `1px solid ${theme.palette.divider}`,
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    overflow: "hidden",
    direction: "rtl",
  },
  tableHeadRow: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 1fr 88px 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[400],
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
  },
  tableBodyRow: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 1fr 88px 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  tableHeadRowCompact: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[400],
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
  },
  tableBodyRowCompact: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  tableHeadCell: {
    padding: "0 12px",
    height: "100%",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "21px",
    letterSpacing: 0,
    color: theme.palette.text.primary,
    textAlign: "right",
    direction: "rtl",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    minWidth: 0,
  },
  tableCell: {
    padding: "0 12px",
    minWidth: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    direction: "rtl",
  },
  tableIndexCell: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "21px",
    letterSpacing: 0,
    color: theme.palette.secondary.main,
    textAlign: "center",
    justifyContent: "center",
  },
  tableCellText: {
    width: "100%",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
    wordBreak: "break-word",
  },
  tyingStripModal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: 500,
    boxSizing: "border-box",
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 24px rgba(37, 56, 88, 0.12)",
    outline: "none",
    direction: "rtl",
  },
  tyingStripModalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    width: "100%",
    height: 56,
    boxSizing: "border-box",
    gap: 10,
    padding: "16px 24px",
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    opacity: 1,
    backgroundColor: theme.palette.grey[400],
    direction: "rtl",
  },
  tyingStripModalTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    flex: 1,
    margin: 0,
  },
  tyingStripModalClose: {
    flexShrink: 0,
    padding: 0,
    width: 24,
    height: 24,
    color: theme.palette.text.primary,
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  },
  tyingStripModalBody: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "16px 24px",
    backgroundColor: theme.palette.background.paper,
    direction: "rtl",
  },
  tyingStripModalField: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: "100%",
    opacity: 1,
  },
  tyingStripModalLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    margin: 0,
  },
  tyingStripModalInput: {
    width: "100%",
    margin: 0,
    opacity: 1,
    "& .MuiOutlinedInput-root": {
      height: 48,
      margin: 0,
      boxSizing: "border-box",
      borderRadius: "4px",
      backgroundColor: theme.palette.background.paper,
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
      opacity: 1,
      "& fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: "1px",
      },
    },
    "& .MuiOutlinedInput-input": {
      height: "100%",
      boxSizing: "border-box",
      padding: "12px 8px 12px 16px",
      textAlign: "right",
      direction: "rtl",
      "&::placeholder": {
        color: theme.palette.text.disabled,
        opacity: 1,
      },
    },
  },
  tyingStripModalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexShrink: 0,
    width: "100%",
    height: 68,
    boxSizing: "border-box",
    gap: 6,
    padding: "16px 24px",
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    opacity: 1,
    backgroundColor: theme.palette.grey[400],
    direction: "rtl",
  },
  tyingStripModalCancelBtn: {
    height: 36,
    padding: "15px 28px",
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.text.primary,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
    textTransform: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:hover": {
      borderColor: theme.palette.text.primary,
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  tyingStripModalAddBtn: {
    height: 36,
    padding: "15px 28px",
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: `${theme.palette.divider} !important`,
      borderColor: theme.palette.divider,
      color: `${theme.palette.text.disabled} !important`,
    },
  },
  rowModal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: 500,
    boxSizing: "border-box",
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 24px rgba(37, 56, 88, 0.12)",
    outline: "none",
    direction: "rtl",
  },
  rowModalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    width: "100%",
    height: 56,
    boxSizing: "border-box",
    gap: 10,
    padding: "16px 24px",
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    backgroundColor: theme.palette.grey[400],
    direction: "rtl",
  },
  rowModalTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    flex: 1,
    margin: 0,
  },
  rowModalClose: {
    flexShrink: 0,
    padding: 0,
    width: 24,
    height: 24,
    color: theme.palette.text.primary,
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  },
  rowModalBody: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "16px 24px",
    backgroundColor: theme.palette.background.paper,
    direction: "rtl",
  },
  rowModalFieldsRow: {
    display: "flex",
    gap: 10,
    width: "100%",
    direction: "rtl",
    alignItems: "flex-start",
  },
  rowModalField: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: "100%",
    minWidth: 0,
  },
  rowModalFieldGrow: {
    flex: 1,
    minWidth: 0,
  },
  rowModalFieldNarrow: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: 100,
    flexShrink: 0,
  },
  rowModalLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    margin: 0,
    width: "100%",
  },
  rowModalInput: {
    width: "100%",
    margin: 0,
    "& .MuiOutlinedInput-root": {
      height: 48,
      margin: 0,
      boxSizing: "border-box",
      borderRadius: "4px",
      backgroundColor: theme.palette.background.paper,
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
      "& fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: "1px",
      },
    },
    "& .MuiOutlinedInput-input": {
      height: "100%",
      boxSizing: "border-box",
      padding: "12px 8px 12px 16px",
      textAlign: "right",
      direction: "rtl",
      "&::placeholder": {
        color: theme.palette.text.primary,
        opacity: 1,
      },
    },
  },
  rowModalSelectControl: {
    width: "100%",
    minWidth: 0,
    margin: 0,
  },
  rowModalSelect: {
    direction: "rtl",
    width: "100%",
    height: 48,
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.secondary.main,
    boxSizing: "border-box",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.divider,
      borderWidth: 1,
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      height: 48,
      minHeight: "48px !important",
      paddingTop: "12px !important",
      paddingRight: "16px !important",
      paddingBottom: "12px !important",
      paddingLeft: "38px !important",
      direction: "rtl",
      boxSizing: "border-box",
    },
    "& .MuiSelect-icon": {
      left: "8px !important",
      right: "auto !important",
      top: "50%",
      transform: "translateY(-50%) rotate(0deg)",
    },
  },
  rowModalSelectValue: {
    display: "block",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.palette.text.primary,
  },
  rowModalStepper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    direction: "ltr",
    width: "100%",
    height: 48,
    gap: 10,
    paddingTop: 12,
    paddingRight: 16,
    paddingBottom: 12,
    paddingLeft: 8,
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.background.paper,
    boxSizing: "border-box",
  },
  rowModalStepperArrows: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: theme.palette.text.primary,
  },
  rowModalStepperArrow: {
    fontSize: "16px !important",
    height: 12,
    cursor: "pointer",
    color: theme.palette.text.primary,
  },
  rowModalStepperValue: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    textAlign: "right",
    flex: 1,
  },
  rowModalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexShrink: 0,
    width: "100%",
    height: 68,
    boxSizing: "border-box",
    gap: 6,
    padding: "16px 24px",
    borderBottomRightRadius: 6,
    borderBottomLeftRadius: 6,
    backgroundColor: theme.palette.grey[400],
    direction: "rtl",
  },
  rowModalCancelBtn: {
    height: 36,
    padding: "15px 28px",
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.text.primary,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
    textTransform: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:hover": {
      borderColor: theme.palette.text.primary,
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  rowModalAddBtn: {
    height: 36,
    padding: "15px 28px",
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1,
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: `${theme.palette.divider} !important`,
      borderColor: theme.palette.divider,
      color: `${theme.palette.text.disabled} !important`,
    },
  },
}));
